// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCPBHXebSbe3P9tMRz0RI-z6sEI8yrtTmM",
  authDomain: "projectmonitor-bfddb.firebaseapp.com",
  projectId: "projectmonitor-bfddb",
  storageBucket: "projectmonitor-bfddb.appspot.com",
  messagingSenderId: "100999010397",
  appId: "1:100999010397:web:ad4a43baa746d912ba15b4",
  measurementId: "G-PY7YFS0NFN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

export { db };
